import React from 'react';

export function Badge({
  children,
  variant = 'default', // 'default' | 'success' | 'warning' | 'danger' | 'info' | 'purple' | 'outline'
  size = 'md', // 'sm' | 'md'
  icon: Icon,
  className = '',
  style = {}
}) {
  const variantStyles = {
    default: { background: 'rgba(148, 163, 184, 0.15)', color: '#CBD5E1', border: '1px solid rgba(148, 163, 184, 0.2)' },
    success: { background: 'rgba(5, 150, 105, 0.15)', color: '#34D399', border: '1px solid rgba(5, 150, 105, 0.3)' },
    warning: { background: 'rgba(245, 158, 11, 0.15)', color: '#FBBF24', border: '1px solid rgba(245, 158, 11, 0.3)' },
    danger: { background: 'rgba(220, 38, 38, 0.15)', color: '#F87171', border: '1px solid rgba(220, 38, 38, 0.3)' },
    info: { background: 'rgba(2, 132, 199, 0.15)', color: '#38BDF8', border: '1px solid rgba(2, 132, 199, 0.3)' },
    purple: { background: 'rgba(139, 92, 246, 0.15)', color: '#A78BFA', border: '1px solid rgba(139, 92, 246, 0.3)' },
    outline: { background: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }
  };

  const sizeStyles = {
    sm: { padding: '2px 8px', fontSize: '11px', gap: '4px' },
    md: { padding: '4px 10px', fontSize: '12px', gap: '6px' }
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: 600,
        borderRadius: 'var(--radius-full)',
        lineHeight: 1,
        ...sizeStyles[size],
        ...variantStyles[variant],
        ...style
      }}
      className={className}
    >
      {Icon && <Icon size={size === 'sm' ? 12 : 14} />}
      {children}
    </span>
  );
}

export default Badge;
